import React from 'react';
import { Box } from '@mantine/core';
import { JournalEntriesView } from '../../common/JournalEntriesView';

export interface EntityDetailJournalTabProps {
    entityType: string;
    targetId: string;
    currentEntity: any;
}

export const EntityDetailJournalTab: React.FC<EntityDetailJournalTabProps> = ({
    entityType,
    targetId,
    currentEntity,
}) => {
    return (
        <Box>
            <JournalEntriesView
                entityType={entityType}
                targetId={targetId}
                currentEntity={currentEntity}
            />
        </Box>
    );
};

